import { Platform } from 'react-native'
import Constants from 'expo-constants'

export const extra = Constants.expoConfig.extra
export const SERVER = Platform.OS === 'web' && extra.env !== 'local' ? window.location.origin : extra.server
export const NEW_UI = true
export const MAX_CONTENT_WIDTH = 1100